import React, { Component } from 'react'
import Modal, { ModalHeader, ModalBody } from '../Modal';
import NavLinkScrollTop from '../NavLinkScrollTop';
import localize from '../localize';
import './Assessment.css';

export class Assessment extends Component {
  getContent() {
    const { i18n, data: { player, isp, bestIsp }, close } = this.props

    if (!player || !isp || !bestIsp || !player.stats_overall || !isp.stats_ethernet || !bestIsp.stats_ethernet) {
      return <div/>
    }

    const worseThanIsp = player.stats_overall.connection_score <= (isp.stats_ethernet.connection_score - 5)
    const ispWorseThanBest = isp.stats_ethernet.connection_score <= (bestIsp.stats_ethernet.connection_score - 5)

    const wifiBlock = [
        <div className="assessment-tip" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.ethernet') }} />,
        <div className="assessment-tip" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.5ghz') }} />
    ]

    var content = <div/>
    if (!worseThanIsp && !ispWorseThanBest) {
      content = (
        <div>
          <div className="assessment-section-header" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.best') }} />
          <div className="assessment-footer">
            <q-button onClick={close}>{i18n.t('feedback.thank_you.close')}</q-button>
          </div>
        </div>
      )
    } else if (worseThanIsp && !ispWorseThanBest) {
      content = (
        <div>
          <div className="assessment-section-header" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.isp_tips_best') }} />
          { player.stats_wireless? wifiBlock : [] }
          <div className="assessment-tip" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.reset') }} />
          <div className="assessment-tip" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.qos') }} />
          <div className="assessment-tip" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.contact') }} />
          <div className="assessment-footer">
            <NavLinkScrollTop to="/steps"><q-button onClick={close}>{i18n.t('pages.scores.assessment.what_else')}</q-button></NavLinkScrollTop>
          </div>
        </div>
      )
    } else if (ispWorseThanBest && !worseThanIsp) {
      content = (
        <div>
          <div className="assessment-section-header" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.other_providers') }} />
          <div className="assessment-tip" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.not_satisfied') }} />
          <div className="assessment-footer">
            <NavLinkScrollTop to="/steps"><q-button onClick={close}>{i18n.t('pages.scores.assessment.what_else')}</q-button></NavLinkScrollTop>
          </div>
        </div>
      )
    } else {
      content = (
        <div>
          <div className="assessment-section-header" dangerouslySetInnerHTML={{ __html: i18n.t('isp_tips') }} />
          { player.stats_wireless? wifiBlock : [] }
          <div className="assessment-tip"dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.reset') }} />
          <div className="assessment-tip" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.qos') }} />
          <div className="assessment-tip" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.contact') }} />
          <div className="assessment-section-header" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.other_providers_also') }} />
          <div className="assessment-tip" dangerouslySetInnerHTML={{ __html: i18n.t('pages.scores.assessment.not_satisfied') }} />
          <div className="assessment-footer">
            <NavLinkScrollTop to="/steps"><q-button onClick={close}>{i18n.t('pages.scores.assessment.what_else')}</q-button></NavLinkScrollTop>
          </div>
        </div>
      )
    }

    return (
      <div className="assessment-body">
        {content}
      </div>
    )
  }

  render() {
    const { i18n, open, close, isOpen } = this.props
    return (
      <div className="assessment-container">
        <div className="assessment-inline" onClick={open}>
          <div className="assessment-icon" />
        </div>
        <Modal isOpen={isOpen} handleModalClose={close} contentLabel="Modal">
          <ModalHeader>
            <h1>{i18n.t('pages.scores.assessment.header')}</h1>
            <h2>{i18n.t('pages.scores.assessment.subheader')}</h2>
          </ModalHeader>
          <ModalBody>
            {this.getContent()}
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default localize()(Assessment)



// WEBPACK FOOTER //
// ./src/components/Assessment/index.js